module.exports = __webpack_public_path__ + "media/images/web/home/index/what_is_nomiri-cfdeaa6d7ab5cb81067875d1c2e879ea.jpg";